import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import { PostData } from '../../services/PostData';
import { GetData } from '../../services/GetData';
import {
	Row,
	Col,
	Button,
	ButtonDropdown,
	DropdownToggle,
	DropdownMenu,
	DropdownItem,
	Card,
	CardHeader,
	CardFooter,
	CardBody,
	Collapse,
	Form,
	FormGroup,
	FormText,
	Label,
	Input,
	InputGroup,
	InputGroupAddon,
	InputGroupText,
	Table,
	Modal, ModalHeader, ModalBody, ModalFooter
} from 'reactstrap';
import $ from 'jquery';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import 'react-datepicker/dist/react-datepicker.css';
import FullCalendar from 'fullcalendar-reactwrapper';
import 'fullcalendar-reactwrapper/dist/css/fullcalendar.min.css';
import SettingsPage from '../../views/SettingsPage/';
const GLOBAL = require('../../Globals');
import Select from 'react-select';
import 'react-select/dist/react-select.css';

class LeaveEntry extends Component {

	constructor(props) {
		super(props);
		this.state = {
			acyear: '',
			month: '',
			cls: '',
			day: '',
			hour: '',
			title: '',
			sdate: moment(),
			tdate: '',
			leatype: '',
			_message: '',
			alertClass: '',
			posts: [],
			accyear: [],
			_redirect: false,
			modal: false,
			// description : [],
			ltype: [],
			events: [],
			chk: '',
			data: [],
			show: false,
			classes: [],
		}
		this.onChange = this.onChange.bind(this);
		this.onClassChange = this.onClassChange.bind(this);
		this.onDateChange = this.onDateChange.bind(this);
		this.onDatChange = this.onDatChange.bind(this);
		this.onBack = this.onBack.bind(this);
		this.toggle = this.toggle.bind(this);
		this.onAdd = this.onAdd.bind(this);
		this.onChkChange = this.onChkChange.bind(this);
		this.onShowCalender = this.onShowCalender.bind(this);
	}

	onClassChange(sclass) {
		this.state.classes = [];
		{
			sclass.map(item =>

				this.state.classes.push(item.value)
			)
		}
		this.setState({ sclass });
	}

	onhandleRemove(id, e) {

		this.state.id = id;
		if (window.confirm("Do you want to Delete?")) {
			$("#showLoader").show();
			PostData('student/deleteleave', this.state).then((result) => {
				$("#showLoader").hide();
				let responseJson = result;

				if (responseJson.status == '1') {
					this.setState({
						_message: 'Leave Removed Successfullly',
						alertClass: 'alert alert-success'
					});
					this.getdata();
				}
				else {

					this.setState({
						_message: 'Error',
						alertClass: 'alert alert-danger'
					});
				}
			});
		}
	}

	onShowCalender() {

		this.setState({ show: true });
	}

	onChkChange(e) {

		if (e.target.checked) {

			this.state.chk = '1';
		}
		else {

			this.state.chk = '0';
		}
	}

	onAdd(e) {

		// this.state.events.push({"title": this.state.title,"start":this.state.sdate});
		$("#showLoader").show();
		PostData('student/addleave', this.state).then((result) => {
			$("#showLoader").hide();
			let responseJson = result;
			// console.log(responseJson);
			if (responseJson.status == '1') {
				this.setState({
					classes: [],
				});
				// alert('Leave Days Added Successfully!..');
				// document.getElementById("attform").reset();
				this.getdata();
			}
			else {

				this.getdata();
			}
		});
		this.toggle();
	}

	/** set value to Leave Entry From datepicker **/
	onDateChange(date) {
		this.setState({
			sdate: date
		});
	}

	/** set value to Leave Entry To datepicker **/
	onDatChange(date) {
		this.setState({
			tdate: date
		});
	}

	toggle() {
		this.setState({
			modal: !this.state.modal
		});
	}

	/** redirect to Attendance view **/
	onBack(e) {

		this.setState({
			modal: !this.state.modal
		});
		// alert('sfsag');
	}

	/** Leave Description */
	/* handleChange(id,e){
		
		if(e!=null && e.target.value.length>0){
		
			if(this.state.description.length < 1){
				
				this.state.description.push('{"id":'+id+', "desc":"'+e.target.value+'"}');
			}
			else{
				
				var index = this.state.description.findIndex(function(objstr){
				var tes = JSON.parse(objstr);
				return (tes.id == id); });
				
					if(index === -1){ 
					
						this.state.description.push('{"id":'+id+', "desc":"'+e.target.value+'"}');
					}
					else{
						
						var index2 = this.state.description.findIndex(function(objstr){
						var tes = JSON.parse(objstr);
						return (tes.id == id);});
						
						this.state.description.splice(index2,1);
						this.state.description.push('{"id":'+id+', "desc":"'+e.target.value+'"}');
					}
				console.log(this.state.description);
			}
		
		}
		
	} */
	handleChange(id, e) {

		this.setState({
			modal: !this.state.modal
		});
		this.state.day = id;
		this.state.hour = e.target.value;
	}

	/** Leave type */
	onSelectChange(id, e) {

		if (this.state.ltype.length < 1)
			this.state.ltype.push('{"id":' + id + ',"leatype":"' + e.target.value + '"}');

		this.state.ltype.map((obj, k) => {
			var tes = JSON.parse(obj);
			if (tes.id == id)
				tes.leatype = e.target.value;
			else
				this.state.ltype.push('{"id":' + id + ',"leatype":"' + e.target.value + '"}');
		});
	}

	onChange(e) {

		this.setState({ [e.target.name]: e.target.value });
	}

	/** this function will be call when page loading **/
	componentWillMount() {

		this.getclass();
		this.getacyear();
		this.getdata();
	}

	/** get Class **/
	getdata() {
		$("#showLoader").show();
		GetData('student/getleave').then((result) => {
			$("#showLoader").hide();
			let responseJson = result;
			if (responseJson) {
				this.setState({
					events: responseJson
				});
			}
		});
	}

	/** get Class **/
	getclass() {

		GetData('classs/getclass').then((result) => {
			let responseJson = result;
			if (responseJson) {
				this.setState({
					posts: responseJson
				});
			}
		});
	}

	/** Get Academic Year **/
	getacyear() {

		GetData('academic/getacyear').then((result) => {
			let responseJson = result;
			if (responseJson) {
				this.setState({
					accyear: responseJson
				});
			}
		});
	}

	daysInMonth() {

		var month = $("#month").val();
		var year = $("#syear").val();
		var ndays = new Date(year, month, 0).getDate();
		return ndays + 1;
	}

	/* getdays(){
		var days = [];
		
		var leavetype = [
			{value : '', name: 'Select Type'},
			{value : 'Leave', name: 'Leave'},
			{value : 'OD', name: 'OD'},
			{value : 'Local Holiday', name: 'Local Holiday'},
			{value : 'Others', name: 'Others'}
		];
		
		for(var i=1; i<this.daysInMonth(); i++){
			
			if(this.checksunday(i)){
				
				days.push(<tr><td></td><td></td><td></td></tr>);
			}
			else{
				days.push(<tr><td>{i}</td><td><Input type="textarea" name="remarks" onChange={this.emptyhandler} onBlur={this.handleChange.bind(this,i)} /></td><td><select name="ltype" className="form-control" onChange={this.onSelectChange.bind(this,i)}>
					{leavetype.map((e, key) => {
						return <option key={key} value={e.value}>{e.name}</option>;
					})}		
				</select></td></tr>);
			}
		}
		
		return days;
	} */

	getdays() {

		var days = [];

		var j = 0;
		for (var i = 1; i < this.daysInMonth(); i++) {

			/* if(j==0){
				
				days.push(<tr>);
			} */
			if (this.checkdays(i)) {

				days.push(<td><Button size="sm" color="danger" value={i} onClick={this.handleChange.bind(this, j)}> {i}</Button></td>);
			}
			else {

				days.push(<td><Button size="sm" color="primary" value={i} onClick={this.handleChange.bind(this, j)}> {i}</Button></td>);
			}
			j++;
			if (j == 7) {

				// days.push(<tr>);
				j = 0;
			}
		}

		return days;
	}

	checkdays(dat) {

		var bstate = false;
		var month = $("#month").val();
		var year = $("#syear").val();

		var newDate = new Date('' + year + '-' + month + '-' + dat);
		// console.log('date '+newDate);
		if (newDate.getDay() == 0) {   //if Sunday
			bstate = true;
		}
		/* else if(newDate.getDay()==1){   //if Monday
			bstate=true;
		} */
		else {  //if Saturday
			bstate = false;
		}
		return bstate;
	}

	gethours() {

		var day = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

		var tabtd = [];

		for (var k = 0; k < 7; k++) {

			tabtd.push(
				<th>{day[k]}</th>
			);
		}
		return tabtd;
	}

	getday(start, end) {

		var day = [];

		if (this.checkday != '') {
			day.push(<td>{this.checkday(start, end)}</td>);
		}
		else {
			day.push(<td></td>);
		}

		return day;
	}

	checkday(start, end) {

		var bstate = '';
		var days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
		var d = new Date(start);
		var dayName = days[d.getDay()];

		var d1 = new Date(end);
		var dayName1 = days[d1.getDay()];

		if (start === end) {

			return bstate = dayName;
		}
		else {

			return bstate = dayName + ' - ' + dayName1;
		}
	}

	getpreviousd(end) {

		var ed = new Date(end);
		var edate = ed.setDate(ed.getDate() - 1);

		var d = new Date(edate),
			month = '' + (d.getMonth() + 1),
			day = '' + d.getDate(),
			year = d.getFullYear();

		if (month.length < 2) month = '0' + month;
		if (day.length < 2) day = '0' + day;

		return [year, month, day].join('-');
	}

	checkdate(start, end) {

		var d = new Date(start),
			month = '' + (d.getMonth() + 1),
			day = '' + d.getDate(),
			year = d.getFullYear();

		if (month.length < 2) month = '0' + month;
		if (day.length < 2) day = '0' + day;

		var d1 = new Date(end),
			month1 = '' + (d1.getMonth() + 1),
			day1 = '' + d1.getDate(),
			year1 = d1.getFullYear();

		if (month1.length < 2) month1 = '0' + month1;
		if (day1.length < 2) day1 = '0' + day1;

		if (start === end) {

			return [day, month, year].join('-');
		}
		else {

			return [day, month, year].join('-') + ' - ' + [day1, month1, year1].join('-');;
		}

	}

	render() {

		var leavetype = [
			{ value: '', name: 'Select Type' },
			{ value: 'Festival Holiday', name: 'Festival Holiday' },
			{ value: 'Local Holiday', name: 'Local Holiday' },
			{ value: 'Others', name: 'Others' }
		];

		/** disable weekend(sunday) in react-datepicker **/
		var isWeekday = (date) => {
			const day = date.day()
			return day !== 0 && day !== 7
		}

		if (this.state._redirect) {

			return (<Redirect to='/student/attendanceview' />);
		}
		var cls = [];
		cls.push({ value: "all", label: 'All' });
		this.state.posts.map(function (e, key) {
			cls.push({ value: e.id, label: e.class });
		});

		if (this.state.acyear != '' && this.state.month != '' && this.state.cls) {

			$("#leatab").show();

		}
		else {

			$("#leatab").hide();
		}

		if ($('#chktdate').prop('checked')) {

			$("#todate").show();

		} else {

			$("#todate").hide();
		}


		if (this.state.show == true) {

			$("#showcalender").show();
		}
		else {

			$("#showcalender").hide();
		}

		return (
			<div>
				<SettingsPage />
				<div className="animated fadeIn">
					<div className={this.state.alertClass}>
						{this.state._message}
					</div>
					<Row>
						<Col md="12" id="attab">
							<Card>
								<CardHeader>
									<strong>School Leave Days</strong>
									<span className="pull-right">
										<Button outline color="primary" id="vicalend" onClick={this.onShowCalender} >Calender View</Button>&nbsp;&nbsp;
										<Button outline color="primary" onClick={this.onBack}>Add</Button>
									</span>
								</CardHeader>
								<CardBody>
									<Row>
										<Col md="12">
											<Table responsive bordered >
												<thead>
													<tr>
														<th>S.No</th>
														<th>Date</th>
														<th>Title</th>
														<th>No Of Days</th>
														<th>Day</th>
														<th>Leave Type</th>
														<th>Manage</th>
													</tr>
												</thead>
												<tbody>
													{this.state.events.map((item, index) =>

														<tr key={index}>
															<td>{index + 1}</td>
															<td>{this.checkdate(item.start, this.getpreviousd(item.end))}</td>
															<td>{item.title}</td>
															<td>{item.countdays}</td>
															{this.getday(item.start, this.getpreviousd(item.end))}
															<td>{item.leavetype}</td>
															<td><button name="removesub" className="btn btn-danger btn-sm" onClick={this.onhandleRemove.bind(this, item.id)} ><i className="fa fa-remove"></i></button></td>
														</tr>
													)}
												</tbody>
											</Table>
										</Col>
										<Col md="12" id="showcalender">
											<div id="example-component">
												<FullCalendar
													id="your-custom-ID"
													header={{
														left: 'prev,next today myCustomButton',
														center: 'title',
														right: 'month,basicWeek,basicDay'
													}}
													businessHours={true}
													navLinks={true} // can click day/week names to navigate views
													// editable= {true}
													eventLimit={true} // allow "more" link when too many events
													events={this.state.events}
												/>
											</div>
										</Col>
										<Modal isOpen={this.state.modal} toggle={this.toggle} className={this.props.className}>
											<ModalHeader toggle={this.toggle}>Select</ModalHeader>
											<ModalBody>
												<Row>
													<Col md="12">
														<FormGroup>
															<Label htmlFor="name">Leave Description <span className="text-danger">*</span></Label>
															<input type="text" name="title" onChange={this.onChange} className="form-control" />
														</FormGroup>
													</Col>
													<Row id="datesty">
														<Col md="5">
															<FormGroup>
																<Label htmlFor="name">From Date <span className="text-danger">*</span></Label>
																<DatePicker selected={this.state.sdate} onChange={this.onDateChange} className="leadate form-control" dateFormat="DD-MM-YYYY" filterDate={isWeekday} />
															</FormGroup>
														</Col>
														<Col md="2">
															<Label></Label>
															<input type="checkbox" id="chktdate" onChange={this.onChkChange} />
														</Col>
														<Col md="5" id="todate">
															<FormGroup>
																<Label htmlFor="name">To Date <span className="text-danger">*</span></Label>
																<DatePicker selected={this.state.tdate} onChange={this.onDatChange} className="leadate form-control" dateFormat="DD-MM-YYYY" filterDate={isWeekday} />
															</FormGroup>
														</Col>
													</Row>
													<Col md="12">
														<FormGroup>
															<Label htmlFor="name">Leave type <span className="text-danger">*</span></Label>
															<select name="leatype" className="form-control" onChange={this.onChange}>
																{leavetype.map((e, key) => {
																	return <option key={key} value={e.value}>{e.name}</option>;
																})}
															</select>
														</FormGroup>
													</Col>
													<Col md="12">
														<Label htmlFor="name">Class</Label>
														<FormGroup>
															<Select value={this.state.classes} onChange={this.onClassChange} multi options={cls} />
														</FormGroup>
													</Col>
												</Row>
											</ModalBody>
											<ModalFooter>
												<Button type="submit" color="primary" onClick={this.onAdd}>Add</Button>
											</ModalFooter>
										</Modal>
									</Row>
								</CardBody>
							</Card>
						</Col>
					</Row>
				</div>
			</div>
		)
	}
}

export default LeaveEntry;


// WEBPACK FOOTER //
// ./src/student/LeaveEntry/LeaveEntry.js